import React, { useEffect, useState } from "react";

// import "react-responsive-carousel/lib/styles/carousel.min.css";

const {
  sideImg1,
  sideImg2,
  sideImg3,
  tramImage,
  transGuideImage,
  transGuideImageSmall,
} = window.ASSETS;

const Home = () => {
  document.title = "Banglar Transit";
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowResize);
  }, []);

  return (
    <main className="mb-28">
      <div className="mb-12 bg-black relative">
        <img
          src={windowWidth < 640 ? transGuideImageSmall : transGuideImage}
          alt="transport guide cover"
          className="w-full opacity-50"
        />

        <div
          className="absolute top-[20%] left-[10%] sm:left-10 text-white grid md:gap-1.5 lg:gap-2.5 font-fam-special-elite animate-fade-in-up"
          style={{ animationDelay: "0.2s" }}
        >
          <div className="text-lg md:text-2xl lg:text-3xl">YOUR OWN</div>
          <div className="text-4xl md:text-5xl lg:text-7xl font-fam-rubik-dirt">
            TRANSPORT
          </div>
          <div className="text-lg md:text-2xl lg:text-3xl text-right">
            GUIDE
          </div>
        </div>

        <div
          className="absolute top-[50%] sm:top-[70%] left-[10%] sm:left-10 flex flex-col text-white text-md lg:text-xl font-fam-special-elite animate-fade-in-up"
          style={{ animationDelay: "0.4s" }}
        >
          <span> Now Including </span>
          <span> - 450+ pictures </span>
          <span> - 800+ routes </span>
        </div>
      </div>

      <div className="font-fam-sarabun pb-10 md:pb-0">
        <div
          className="flex flex-col sm:items-center sm:flex-row sm:gap-8 bg-accent-back drop-shadow-sm mb-8 animate-fade-in-up"
          id="introduction"
          style={{ animationDelay: "0.6s" }}
        >
          <img
            src={sideImg1}
            alt="Wooden bus"
            className="h-[240px] sm:h-[168px]"
          />

          <p className="my-4 col-span-2 self-center px-4 sm:pl-0">
            We welcome you to BANGLAR TRANSIT, where we aim to provide you a
            comprehensive guide on transport within the state of West Bengal.
          </p>
        </div>

        <div
          className="flex flex-col sm:items-center sm:flex-row sm:gap-8 bg-accent-back drop-shadow-sm mb-8 animate-fade-in-up"
          id="navguide"
          style={{ animationDelay: "0.8s" }}
        >
          <img
            src={sideImg2}
            alt="Garia Nagarik Bus Terminus"
            className="h-[240px] sm:h-[168px]"
          />

          <p className="my-4 col-span-2 self-center px-4 sm:pl-0">
            To get started, you can either search for routes in
            <span className="font-semibold"> Search for routes </span> menu
            option, or explore bus routes categorically through the
            <span className="font-semibold"> Bus Explorer </span> menu option.
          </p>
        </div>

        <div
          className="flex flex-col sm:items-center sm:flex-row sm:gap-8 bg-accent-back drop-shadow-sm mb-8 animate-fade-in-up"
          id="tramguide"
          style={{ animationDelay: "1.0s" }}
        >
          <img
            src={tramImage}
            alt="Tollygunge Tram"
            className="h-[240px] sm:h-[168px]"
          />

          <p className="my-4 col-span-2 self-center px-4 sm:pl-0">
            Now we have tram routes too. Just head on to the
            <span className="font-semibold"> Trams </span> section.
          </p>
        </div>

        <div
          className="flex flex-col md:items-center md:flex-row-reverse md:gap-8 bg-accent-back drop-shadow-sm my-8 md:my-0 animate-fade-in-up"
          id="scope"
          style={{ animationDelay: "1.2s" }}
        >
          <img
            src={sideImg3}
            alt="Esplanade Bus terminus"
            className="h-[300px] md:h-[168px]"
          />

          <p className="my-4 col-span-2 self-center px-4 sm:pr-0">
            Currently most of the focus has been made towards the bus and tram
            services in and around Kolkata. But we aim to gradually increase our
            coverage to the whole of West Bengal, and include other modes of
            transports, like autos, magics and trekkers.
          </p>
        </div>
      </div>
    </main>
  );
};

export default Home;
